<ng-template #showModal>
    <div id="applyChangesToDevicesPopup" class="card applyChangesToDevicesPopup" dir={{direction}}>
      <div id="applyChangesToDevicespopupBody" class="popup-body">
        <div id="applyChangesToDeviceModalHeader" class="modal-header"> 
          <div id="applyChangesToDeviceModalClose" (click)="dismiss()" class="close_icon">
            <img class="modal-close-icon" alt="close icon" />
          </div>
        </div>
        <div id="applyChangesToDevicesModalBody" class="modal-body">
          <h2><span i18n="@@apply-device.push-changes.push-changes-to-devices">Push changes to devices?</span></h2>
          <div id="applyChangesToDeviceCard" class="card_desc">
            <span i18n="@@apply-device.changes.changes-are-saved">Changes are saved.</span>
            <div id="pushChangesLabel"><span i18n="@@apply-device.push-changes-asset">Would you like to push these changes to all devices currently using 
              this asset?</span></div>
          </div>
        </div>
        <div id="applyChangesToDevicesModalFooter" class="modal-footer card-footer">
          <button type="button" (click)="closeApplyChangesToDevice()" class="btn btn-outline-primary gtmCancelDltContGrp">
            <span i18n="@@apply-device.footer.no">{{no}}</span>
          </button>
          <button type="button" class="btn btn-primary gtmDeleteContGrp btn-yes" (click)="applyChangesToDeviceButton()">
            <span i18n="@@apply-device.footer.yes">{{yes}}</span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>